// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuCheckboxCell-checkbox{border:2px solid #0000}.vuuCheckboxCell-checkbox input:focus-visible+.saltCheckboxIcon{outline:none}.vuuTableCell-editable .vuuCheckboxCell-checkbox:focus-within{border:solid 2px var(--salt-focused-outlineColor)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
